var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-group"},[_c('select',{staticClass:"custom-select",attrs:{"id":_vm.defaultID}},[_c('option',{attrs:{"selected":""}},[_vm._v(_vm._s(_vm.selected))]),_vm._v(" "),_vm._l((_vm.list),function(item,index){return _c('option',{key:index,domProps:{"value":item}},[_vm._v(_vm._s(item))])})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }